/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_AprilInputs */

const es_months_april = /** @type {(inputs: Months_AprilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abril`)
};

const en_months_april = /** @type {(inputs: Months_AprilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`April`)
};

/**
* | output |
* | --- |
* | "April" |
*
* @param {Months_AprilInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_april = /** @type {((inputs?: Months_AprilInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_AprilInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_april(inputs)
	return en_months_april(inputs)
});
export { months_april as "months.april" }